function refineApiSpec(apiSpec) {
  apiSpec.info.title = apiSpec.info.title.replace(/-production|-sandbox/gi, '');
  return apiSpec;
}

export { refineApiSpec };
